var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLoginIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.111,
    height: 16.111,
    viewBox: "0 0 16.111 16.111",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#235efb"
    },
    d: "M14.593,1.518A5.189,5.189,0,0,0,5.986,6.787L.139,12.634A.472.472,0,0,0,0,12.968v2.67a.472.472,0,0,0,.472.472h2.67a.472.472,0,0,0,.334-.138l.667-.668a.472.472,0,0,0,.135-.388L4.2,14.2l.994-.094a.471.471,0,0,0,.425-.425l.094-.994.717.083a.464.464,0,0,0,.368-.116.473.473,0,0,0,.158-.353v-.879h.863a.472.472,0,0,0,.334-.138l1.21-1.194A5.112,5.112,0,0,0,14.593,8.86,5.2,5.2,0,0,0,14.593,1.518ZM13.258,4.855a1.416,1.416,0,1,1,0-2A1.417,1.417,0,0,1,13.258,4.855Z",
    transform: "translate(-0.001 0.001)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLoginIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/login-icon.7de72a357f54f4be15db6962f1707a85.svg";